import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './components/Pages/home';
import Layout from './components/Layout/Layout';

const App = () => {
	

	return (
		<>
		<div>
		<Routes>
		<Route element={<Layout />}>
		<Route path='/' element={<Home />} />
		</Route>
		</Routes>
		</div>
		</>
	);
};

export default App;
